// const api = "http://127.0.0.1:8000/api/";
// const api = "https://techgate.ingeniosvirtuales.com/api/"
// const api = "http://172.200.93.4/api/"
// const api = "http://52.138.86.151/api/"
const api = "https://portalterceros.genserpower.com/api/"
export default api;